import { LOAN_FEE_DOCUMENT_TYPES, validateLoanFeeDocument } from './loan-fee-document';

export function pickLoanFeeDocument(): Promise<FormData | null> {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = LOAN_FEE_DOCUMENT_TYPES.join(',');
    input.oncancel = () => resolve(null);
    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) return resolve(null);
      try {
        validateLoanFeeDocument(file.name, file.size, file.type);
        const form = new FormData();
        form.append('document', file, file.name);
        resolve(form);
      } catch (error) {
        reject(error);
      }
    };
    input.click();
  });
}
